module.exports = __webpack_public_path__ + "img/skull.05d5f32f.svg";